import store from '../store'

// A tradie's own weekly timesheet: fill in the week and send it to the
// project's external supervisor. The page itself says so when no project has
// weekly timesheets turned on.
function requireTradie(_to, _from, next) {
  const user = store.getters['auth/user']
  if (!user || user.user_type !== 'tradie') {
    return next({ name: 'home.welcome-page' })
  }
  next()
}

export default {
  path: '/weekly-timesheet',
  component: () =>
    import(
      /* webpackChunkName: "weekly-timesheet" */ '@/views/weeklyTimesheet/index.vue'
    ),
  beforeEnter: requireTradie,
  children: [
    {
      path: '',
      name: 'weekly-timesheet',
      component: () =>
        import(
          /* webpackChunkName: "weekly-timesheet" */ '@/views/weeklyTimesheet/WeeklyTimesheetPage.vue'
        ),
    },
  ],
}
